import { v4 as uuid } from 'uuid';
import useMutation from 'api/hooks/useMutation';
import permissions from 'api/Apollo/permissions';
import useTrackWithUser from 'api/hooks/useTrackWithUser';
import { SCHEMAS_QUERY } from 'api/schemas/schemas-query-builder';
import { GET_SCHEMA_NAMES } from 'api/schemas/schema-names-query-builder';

import { mutation, buildVariables as buildInsertSchemaVariables } from './insert-schema-mutation-builder';

export default function useInsertSchema(options = {}) {
  const [trackWithUser] = useTrackWithUser('schema_created');
  const [executeMutation, response] = useMutation(mutation, {
    ...options,
    refetchQueries: [SCHEMAS_QUERY, { query: GET_SCHEMA_NAMES }],
    context: { permission: permissions.createSchemas },
  });

  const insertSchemaMutation = ({ name, description, jsonSchema }) => {
    const id = uuid();
    return executeMutation({
      variables: {
        ...buildInsertSchemaVariables({
          id,
          name,
          description,
          jsonSchema,
        }),
      },
    }).then(response => {
      if (!response.errors) {
        const id = response.data.insert_schemas_one.id;

        trackWithUser({ id, name, description });
      }
      return response;
    });
  };

  return [insertSchemaMutation, response];
}
